import React from 'react';
import './App.css';
import { HomePage } from './pages/home.component'

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <HomePage />
      </header>
    </div>
  );
}

export default App;
